// @flow

import styled, { css } from "styled-components";
import greyhoundImage from "@fdr/static-ui/images//gh-video-placeholder.jpg";
import horseImage from "@fdr/static-ui/images/hr-video-placeholder.jpg";
import buildColor from "@fdr/static-ui/ColorPalette";

const InlinePlayer = css`
  ${({ isSticky }) =>
    isSticky
      ? css`
          position: sticky;
          top: 0;
          z-index: 10;
        `
      : css`
          position: relative;
        `};
  width: 100%;
  border-radius: ${({ isFDTV }) => (isFDTV ? 0 : "2px")};
  overflow: hidden;
  ${({ aspectRatio }) =>
    aspectRatio
      ? css`
          height: 0;
          padding-top: 56.25%; /* 16:9 aspect ratio */
        `
      : css`
          height: 153px;
        `};
`;

const computeTopPosition = (isFDTV, withFixedBanner) => {
  if (isFDTV) {
    return withFixedBanner ? "78px" : "44px";
  }
  return withFixedBanner ? "82px" : "48px";
};

const ModalPlayer = css`
  position: sticky;
  top: ${({ isFDTV, withFixedBanner }) =>
    computeTopPosition(isFDTV, withFixedBanner)};
  left: 0;
  right: 0;
  z-index: 30;
`;

export const VideoContainer = styled.div`
  ${({ isInline }) => (isInline ? InlinePlayer : ModalPlayer)};
`;

export const InlinePlayerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: stretch;
  justify-content: center;
  ${(props) =>
    props.isPlaying
      ? css`
          background-color: ${buildColor("black", "100")};
        `
      : css`
          ${props.isGreyhound
            ? css`
                background-image: url("${greyhoundImage}");
              `
            : css`
                background-image: url("${horseImage}");
              `};
          ${props.isVideoAvailable
            ? css`
                background-position: 50% 50%;
              `
            : css`
                background-position: 0 0;
              `};
          background-size: cover;
          background-repeat: no-repeat;
        `};
`;

export const PlayButton = styled.button`
  flex: 1 1 0;
  outline: none;
  cursor: ${(props) => (!props.disabled ? "pointer" : "default")};
  background-color: ${buildColor("black", "50")};

  & > span {
    min-height: 56px;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: ${buildColor("white", "100")};
  }
`;
